import Client from "imgix-core-js"

const domain = "derbym-assets.imgix.net"

const Imgix = new Client({
    domain: domain,
    includeLibraryParam: false,
    useHTTPS: true,
})

export const imageSizes = {
    default: {
        "(min-width:1480px)": "740px",
        "(min-width:768px)": "50vw",
        "": "100vw",
    },
    hero: {
        "(min-width:1480px)": "1480px",
        "": "100vw",
    },
    logo: {
        "(min-width:1480px)": "370px",
        "": "50vw",
    },
}

export const placeholderImage = {
    url: "https://derby-assets.error-prelaunch.net/placeholder.jpg",
}

export default Imgix
